import React from 'react';
import Layout from 'components/Layout';
import HeadContent from 'components/HeadContent';
import Books from 'components/Books';
import Footer from 'components/Home/Footer';
import { isApp } from 'services/environment';

function action({ params, query, locationState, store }) {
  const { tab, category, viewType } = params;
  const { dimensions } = store.getState();

  return {
    chunks: ['books'],
    navigation: {
      heading: 'Books',
      section: 'Books',
      left: category ? 'back' : null,
      right: null,
    },
    component: (
      <Layout type="full" withLeaderboardAd={false} withFooter={false}>
        <HeadContent
          contents={{
            title: 'Books',
            description:
              "Explore ckbk's bookshelves which include hundreds of top cookbooks, curated by experts",
          }}
        />
        <Books
          category={category}
          footer={isApp() ? null : <Footer withLeaderboardAd={false} />}
          initialItem={locationState.initialItem || 0}
          orderShelvesBy={params.orderBy}
          orderShelvesByDirection={params.orderByDirection}
          orderBooksBy={query.sort}
          orderBooksByDirection={query.dir}
          searchQuery={query.q}
          shelfStates={locationState || {}}
          tab={tab || 'home'}
          viewType={viewType || (dimensions.displayType === 'mobile' ? 'list' : 'grid')}
        />
      </Layout>
    ),
  };
}

export default action;
